import { isObject } from "@pineapplelab/util";
import { FBase } from "../FBase";

export class Statistics extends FBase {

	totalEarnings: number = null;
	soldCategories: number = null;
	totalOrders: number = null;
	bestSellerCategory: any = null;


	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}

}
export namespace Statistics {
	export const PATH = 'statistics';
}
